/**
 * Ce que la pellicule dit de l'activité d'un élève (pur, sans composant : testé sans Unistyles).
 */
import { type UITutorLiveActivity } from "../../../ports/primary/ui/types/tutorLive"

/** Où il en est d'une activité à quiz (`UITutorLiveActivity.part`), en un mot : la liste et la petite barre le disent. */
export const LIVE_ACTIVITY_PART = { quiz: "Quiz", exercise: "Exercice" } as const

/** L'activité qu'il a devant lui ; à défaut, celle en cours. */
export function tutorStudentOnScreen(student: { activities: UITutorLiveActivity[] }) {
    return (
        student.activities.find((activity) => activity.onScreen === true) ??
        student.activities.find((activity) => activity.status === "current")
    )
}

/**
 * Ce que la liste condensée montre (daily du 04/11) : l'activité en cours (celle qu'il a devant lui, à défaut
 * l'en-cours), puis celle qu'il aura juste après s'il la rend (`next`, que l'adaptateur pose selon la règle de son
 * écran de fin — pas la ligne d'en dessous).
 */
export function tutorLiveCurrentAndNext(activities: UITutorLiveActivity[]): {
    current?: UITutorLiveActivity
    next?: UITutorLiveActivity
} {
    const current = tutorStudentOnScreen({ activities })
    const next = activities.find((activity) => activity.next === true && activity.id !== current?.id)
    return { current, next }
}
